import React, { Component } from 'react';
import { NavLink as Link, withRouter } from 'react-router-dom';
import {
  Collapse,
  Nav,
  Navbar,
  NavbarBrand,
  NavbarToggler,
  NavLink
} from 'reactstrap';

class NavbarCustom extends Component {
  state = {
    isOpen: false
  };

  toggle = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  render() {
    return (
      <Navbar light expand="md">
        <NavbarBrand tag={Link} to="/contact">
          <h3 className="navbar-title">
            Aaron&nbsp;Horan
            <br />
            <span>Photographer</span>
          </h3>
        </NavbarBrand>
        <NavbarToggler onClick={this.toggle} />
        <Collapse isOpen={this.state.isOpen} navbar>
          <Nav className="ml-auto" navbar>
            <NavLink tag={Link} activeClassName={'active-page'} exact to="/">
              Home
            </NavLink>
            <NavLink
              tag={Link}
              activeClassName={'active-page'}
              to="/portraiture"
            >
              Portraiture
            </NavLink>
            <NavLink tag={Link} activeClassName={'active-page'} to="/creepy">
              Creepy
            </NavLink>
            <NavLink
              tag={Link}
              activeClassName={'active-page'}
              to="/south_korea"
            >
              South Korea
            </NavLink>
            <NavLink
              tag={Link}
              activeClassName={'active-page'}
              to="/california"
            >
              California
            </NavLink>
            <NavLink tag={Link} activeClassName={'active-page'} to="/contact">
              Contact
            </NavLink>
          </Nav>
        </Collapse>
      </Navbar>
    );
  }
}

export default withRouter(NavbarCustom);
